// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"IuIff","item":"RNSkh","itemActive":"XT9ja","itemIcon":"D6u0z"};